export default __webpack_public_path__ + "static/media/Scheduling_MRP_Production.55369159.png";